import { Action } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpStatus } from '@core/classes/http-status.class';

import * as Objects from '@core/objects';

import * as Access from '@app/models/access';
import * as Search from '@app/models/search';
import { VersionFeedback } from '@core/models/version-feedback';

export enum ProjectsActionType {

	// EVENT CALLS
	LoadProject = "[Projects] GET - Obtain a project by id",
	LoadProjectSuccess = "[Projects] Obtain a project by id SUCCESS",
	LoadProjectError = "[Projects] Obtain a project by id ERROR",

    SetProjectInfo = "[Projects] POST - Set a new general info text",
    SetProjectInfoSuccess = "[Projects] POST - Set a new general info text SUCCESS",
    SetProjectInfoError = "[Projects] POST - Set a new general info text ERROR",

	LoadWithUploadedVersions = "[Projects] GET - Obtain a project by id to get uploaded versions",
	LoadWithUploadedVersionsSuccess = "[Projects] GET - Obtain a project by id to get uploaded versions SUCCESS",
	LoadWithUploadedVersionsError = "[Projects] GET - Obtain a project by id to get uploaded versions ERROR",

    LoadProjectFiles = "[Projects] GET - Obtain a project files",
    LoadProjectFilesSuccess = "[Projects] GET - Obtain a project files SUCCESS",
    LoadProjectFilesError = "[Projects] GET - Obtain a project files ERROR",

    LoadProjectOriginVersion = "[Projects] GET - Obtain a project origin version",
    LoadProjectOriginVersionSuccess = "[Projects] GET - Obtain a project origin version SUCCESS",
    LoadProjectOriginVersionError = "[Projects] GET - Obtain a project origin version ERROR",

    DeleteOneProjectFile = "[Projects] DELETE - Set one file inactive in project",
    DeleteOneProjectFileSuccess = "[Projects] DELETE - Set one file inactivein project SUCCESS",
    DeleteOneProjectFileError = "[Projects] DELETE - Set one file inactive in project ERROR",

    UploadProjectFiles = "[Projects] PUT - Upload files in project",
    UploadProjectFilesSuccess = "[Projects] PUT - Upload files in project SUCCESS",
    UploadProjectFilesError = "[Projects] PUT - Upload files in project ERROR",

    LoadEditorAssigners = "[Projects - Editor] GET - Obtain assigners",
    LoadEditorAssignersSuccess = "[Projects - Editor] GET - Obtain assigners SUCCESS",
    LoadEditorAssignersError = "[Projects - Editor] GET - Obtain assigners ERROR",

    LoadEditorWorkflowTransitions = "[Projects - Editor] GET - Obtain all workflow transitions",
    LoadEditorWorkflowTransitionsSuccess = "[Projects - Editor] GET - Obtain all workflow transitions SUCCESS",
    LoadEditorWorkflowTransitionsError = "[Projects - Editor] GET - Obtain all workflow transitions by origin ERROR",

    // Carefull: this is only an action to filter transitions for current opened project. 
    SetEditorCurrentWorkflowTransitions = "[Projects - Editor] Obtain current workflow transitions by origin",
    SetEditorCurrentWorkflowTransitionsSuccess = "[Projects - Editor] Obtain current workflow transitions by origin SUCCESS",
    SetEditorCurrentWorkflowTransitionsError = "[Projects - Editor] Obtain current workflow transitions by origin ERROR",

    LoadEditorAccess = "[Projects - Editor] GET - Obtain access",
    LoadEditorSingleAccess = "[Projects - Editor] GET - Obtain access for a single project by id",
    LoadEditorAccessSuccess = "[Projects - Editor] GET - Obtain access SUCCESS",
    LoadEditorAccessError = "[Projects - Editor] GET - Obtain access ERROR",

    SetProjectAssigned = "[Projects] PUT - Set assigned in project",
    SetProjectAssignedSuccess = "[Projects] PUT - Set assigned in project SUCCESS",
    SetProjectAssignedError = "[Projects] PUT - Set assigned in project ERROR",

    SetProjectDue = "[Projects] PUT - Set due date in project",
    SetProjectDueSuccess = "[Projects] PUT - Set due date in project SUCCESS",
    SetProjectDueError = "[Projects] PUT - Set due date in project ERROR",

    SetProjectStatus = "[Projects] PUT - Set status in project",
    SetProjectStatusSuccess = "[Projects] PUT - Set status in project SUCCESS",
    SetProjectStatusError = "[Projects] PUT - Set status in project ERROR",

    SetProjectLabels = "[Projects] PUT - Set labels in project",
    SetProjectLabelsSuccess = "[Projects] PUT - Set labels in project SUCCESS",
    SetProjectLabelsError = "[Projects] PUT - Set labels in project ERROR",

    LoadProjectMessages = "[Projects] GET - Obtain a project messages",
    LoadProjectMessagesSuccess = "[Projects] GET - Obtain a project messages SUCCESS",
    LoadProjectMessagesError = "[Projects] GET - Obtain a project messages ERROR",

    LoadProjectRelatedVersions = "[Projects] GET - Obtain a project version groups",
    LoadProjectRelatedVersionsSuccess = "[Projects] GET - Obtain a project version groups SUCCESS",
    LoadProjectRelatedVersionsError = "[Projects] GET - Obtain a project version groups ERROR",

    LoadProjectUploadedVersions = "[Projects] GET - Obtain a project uploaded versions",
    LoadProjectUploadedVersionsSuccess = "[Projects] GET - Obtain a project uploaded versions SUCCESS",
    LoadProjectUploadedVersionsError = "[Projects] GET - Obtain a project uploaded versions ERROR",

    // updated may-2023 to a contr instead of list of notes.
    LoadProjectFilesNotesCounter = "[Projects] GET - Obtain a project files notes counter",
    LoadProjectFilesNotesCounterSuccess = "[Projects] GET - Obtain a project files notes counter SUCCESS",
    LoadProjectFilesNotesCounterError = "[Projects] GET - Obtain a project files notes counter ERROR",

	LoadPartialProjectSuccess = "[Projects] Obtain a partial project by id when no access SUCCESS",

    LoadEvents = "[Projects] GET - Obtain specific events",
    LoadEventsSuccess = "[Projects] GET - Obtain specific events SUCCESS",
    LoadEventsError = "[Projects] GET - Obtain specific events ERROR",

    LoadProjectEvents = "[Projects] GET - Obtain all project events",
    LoadProjectEventsSuccess = "[Projects] GET - Obtain all project events SUCCESS",
    LoadProjectEventsError = "[Projects] GET - Obtain all project events ERROR",


    LoadVersionsFeedbacks = "[Projects] GET - Obtain some project versions feedbacks",
    LoadVersionsFeedbacksSuccess = "[Projects] GET - Obtain some project versions feedbacks SUCCESS",
    LoadVersionsFeedbacksError = "[Projects] GET - Obtain some project versions feedbacks ERROR",

    SetRelatedVersionStatus = "[Projects] PUT - Set a related version status",
    SetRelatedVersionStatusSuccess = "[Projects] PUT - Set a related  version status SUCCESS",
    SetRelatedVersionStatusError = "[Projects] PUT - Set a related  version status ERROR",

    SetUploadedVersionStatus = "[Projects] PUT - Set a uploaded version status",
    SetUploadedVersionStatusSuccess = "[Projects] PUT - Set a uploaded  version status SUCCESS",
    SetUploadedVersionStatusError = "[Projects] PUT - Set a uploaded  version status ERROR",

    UpdateProject = "[Projects] - Update project by id",
    UpdateProjectMessages = "[Projects] - Update project messages by id from WS event",
    UpdateVersionsFeedbacks = "[Projects] - Update project related version feedbacks by version id from WS event",
    UpdateRelatedVersion = "[Projects] - Update project related versions by version id from WS event",
    
    
    Clear = "[Projects] clear data",
    ClearEditorAccess = "[Projects - Editor] clear project editor access",
    ClearEditorTransitions = "[Projects - Editor] clear project transitions",
    ClearRelatedVersions = "[Projects] clear project version groups",

    // Logbook actions
    ApplyLogbookSearchFilter = "[Projects - Logbook] Add filter",
    RemoveLogbookSearchFilter = "[Projects - Logbook] Remove filter",
    UpdateLogbookResults = "[Projects - Logbook] Update results with filters",

    SetLogbookSearchTerm = "[Projects - Logbook] set search term",
    ClearLogbookSearch = "[Projects - Logbook] clear search term and filters"
}

// Load Available Events
export class LoadProject implements Action {
    readonly type = ProjectsActionType.LoadProject;
    constructor(public projectId: number) {}
}
export class LoadProjectSuccess implements Action {
    readonly type = ProjectsActionType.LoadProjectSuccess;
    constructor(public project: Objects.Request) {}
}

export class LoadProjectError implements Action {
    readonly type = ProjectsActionType.LoadProjectError;
    constructor(public error: HttpErrorResponse,public projectId: number) {}
}
// Edit project actions

export class SetProjectInfo implements Action {
    readonly type = ProjectsActionType.SetProjectInfo;
    constructor(public info: string) {}
}
export class SetProjectInfoSuccess implements Action {
    readonly type = ProjectsActionType.SetProjectInfoSuccess;
    constructor(public project: Objects.Request) {}
}

export class SetProjectInfoError implements Action {
    readonly type = ProjectsActionType.SetProjectInfoError;
    constructor(public error: HttpErrorResponse,public projectId: number) {}
}
// load for specific light options in dashboard
export class LoadWithUploadedVersions implements Action {
    readonly type = ProjectsActionType.LoadWithUploadedVersions;
    constructor(public projectId: number) {}
}
export class LoadWithUploadedVersionsSuccess implements Action {
    readonly type = ProjectsActionType.LoadWithUploadedVersionsSuccess;
    constructor(public project: Objects.Request) {}
}

export class LoadWithUploadedVersionsError implements Action {
    readonly type = ProjectsActionType.LoadWithUploadedVersionsError;
    constructor(public error: HttpErrorResponse,public projectId: number) {}
}

export class LoadProjectFiles implements Action {
    readonly type = ProjectsActionType.LoadProjectFiles;
    constructor() {}
}

export class LoadProjectFilesSuccess implements Action {
    readonly type = ProjectsActionType.LoadProjectFilesSuccess;
    constructor(public files: Array<Objects.File>) {}
}

export class LoadProjectFilesError implements Action {
    readonly type = ProjectsActionType.LoadProjectFilesError;
    constructor(public error: HttpErrorResponse) {}
}

export class LoadProjectOriginVersion implements Action {
    readonly type = ProjectsActionType.LoadProjectOriginVersion;
    constructor() {}
}

export class LoadProjectOriginVersionSuccess implements Action {
    readonly type = ProjectsActionType.LoadProjectOriginVersionSuccess;
    constructor(public versions: Array<Objects.Version>) {}
}

export class LoadProjectOriginVersionError implements Action {
    readonly type = ProjectsActionType.LoadProjectOriginVersionError;
    constructor(public error: HttpErrorResponse) {}
}

export class LoadProjectUploadedVersions implements Action {
    readonly type = ProjectsActionType.LoadProjectUploadedVersions;
    constructor() {}
}

export class LoadProjectUploadedVersionsSuccess implements Action {
    readonly type = ProjectsActionType.LoadProjectUploadedVersionsSuccess;
    constructor(public versions: Array<Objects.Version>) {}
}

export class LoadProjectUploadedVersionsError implements Action {
    readonly type = ProjectsActionType.LoadProjectUploadedVersionsError;
    constructor(public error: HttpErrorResponse) {}
}

export class Clear implements Action {
    readonly type = ProjectsActionType.Clear;
    constructor() {}
}


export class DeleteOneProjectFile implements Action {
    readonly type = ProjectsActionType.DeleteOneProjectFile;
    constructor(public file: Objects.File, public active: boolean) {}
}

export class DeleteOneProjectFileSuccess implements Action {
    readonly type = ProjectsActionType.DeleteOneProjectFileSuccess;
    constructor() {}
}

export class DeleteOneProjectFileError implements Action {
    readonly type = ProjectsActionType.DeleteOneProjectFileError;
    constructor(public error: HttpErrorResponse) {}
}

export class UploadProjectFiles implements Action {
    readonly type = ProjectsActionType.UploadProjectFiles;
    constructor(public files: Array<Objects.File>) {}
}

export class UploadProjectFilesSuccess implements Action {
    readonly type = ProjectsActionType.UploadProjectFilesSuccess;
    constructor(public files: Array<Objects.File>) {}
}

export class UploadProjectFilesError implements Action {
    readonly type = ProjectsActionType.UploadProjectFilesError;
    constructor(public error: HttpErrorResponse) {}
}

export class LoadEditorAssigners implements Action {
    readonly type = ProjectsActionType.LoadEditorAssigners;
    constructor() {}
}

export class LoadEditorAssignersSuccess implements Action {
    readonly type = ProjectsActionType.LoadEditorAssignersSuccess;
    constructor(public users: Objects.User[]) {}
}

export class LoadEditorAssignersError implements Action {
    readonly type = ProjectsActionType.LoadEditorAssignersError;
    constructor(public error: HttpErrorResponse) {}
} 

export class LoadEditorWorkflowTransitions implements Action {
    readonly type = ProjectsActionType.LoadEditorWorkflowTransitions;
    constructor() {}
}

export class LoadEditorWorkflowTransitionsSuccess implements Action {
    readonly type = ProjectsActionType.LoadEditorWorkflowTransitionsSuccess;
    constructor(public transitions: Objects.WorkflowTransition[]) {}
}

export class LoadEditorWorkflowTransitionsError implements Action {
    readonly type = ProjectsActionType.LoadEditorWorkflowTransitionsError;
    constructor(public error: HttpErrorResponse) {}
}

export class SetEditorCurrentWorkflowTransitions implements Action {
    readonly type = ProjectsActionType.SetEditorCurrentWorkflowTransitions;
    constructor(public status: Objects.RequestStatus) {}
}

export class SetEditorCurrentWorkflowTransitionsSuccess implements Action {
    readonly type = ProjectsActionType.SetEditorCurrentWorkflowTransitionsSuccess;
    constructor() {}
}

export class SetEditorCurrentWorkflowTransitionsError implements Action {
    readonly type = ProjectsActionType.SetEditorCurrentWorkflowTransitionsError;
    constructor(public error: HttpErrorResponse) {}
}

export class LoadEditorAccess implements Action {
    readonly type = ProjectsActionType.LoadEditorAccess;
    constructor() {}
}

export class LoadEditorSingleAccess implements Action {
    readonly type = ProjectsActionType.LoadEditorSingleAccess;
    constructor(public projectId: number) {}
}

export class LoadEditorAccessSuccess implements Action {
    readonly type = ProjectsActionType.LoadEditorAccessSuccess;
    constructor(public access: Access.AccessProject) {}
}

export class LoadEditorAccessError implements Action {
    readonly type = ProjectsActionType.LoadEditorAccessError;
    constructor(public error: HttpErrorResponse) {}
}

export class SetProjectAssigned implements Action {
    readonly type = ProjectsActionType.SetProjectAssigned;
    constructor(public user: Objects.User) {}
}

export class SetProjectAssignedSuccess implements Action {
    readonly type = ProjectsActionType.SetProjectAssignedSuccess;
    constructor(public project: Objects.Request) {}
}

export class SetProjectAssignedError implements Action {
    readonly type = ProjectsActionType.SetProjectAssignedError;
    constructor(public error: HttpErrorResponse) {}
}

export class SetProjectDue implements Action {
    readonly type = ProjectsActionType.SetProjectDue;
    constructor(public date: string) {}
}

export class SetProjectDueSuccess implements Action {
    readonly type = ProjectsActionType.SetProjectDueSuccess;
    constructor(public project: Objects.Request) {}
}

export class SetProjectDueError implements Action {
    readonly type = ProjectsActionType.SetProjectDueError;
    constructor(public error: HttpErrorResponse) {}
}

export class SetProjectStatus implements Action {
    readonly type = ProjectsActionType.SetProjectStatus;
    constructor(public status: Objects.RequestStatus) {}
}

export class SetProjectStatusSuccess implements Action {
    readonly type = ProjectsActionType.SetProjectStatusSuccess;
    constructor(public project: Objects.Request) {}
}

export class SetProjectStatusError implements Action {
    readonly type = ProjectsActionType.SetProjectStatusError;
    constructor(public error: HttpErrorResponse) {}
}

export class SetProjectLabels implements Action {
    readonly type = ProjectsActionType.SetProjectLabels;
    constructor(public labels: Array<Objects.Label>) {}
}

export class SetProjectLabelsSuccess implements Action {
    readonly type = ProjectsActionType.SetProjectLabelsSuccess;
    constructor(public project: Objects.Request) {}
}

export class SetProjectLabelsError implements Action {
    readonly type = ProjectsActionType.SetProjectLabelsError;
    constructor(public error: HttpErrorResponse) {}
}

export class LoadProjectMessages implements Action {
    readonly type = ProjectsActionType.LoadProjectMessages;
    constructor() {}
}

export class LoadProjectMessagesSuccess implements Action {
    readonly type = ProjectsActionType.LoadProjectMessagesSuccess;
    constructor(public messages: Array<Objects.Message>) {}
}

export class LoadProjectMessagesError implements Action {
    readonly type = ProjectsActionType.LoadProjectMessagesError;
    constructor(public error: HttpErrorResponse) {}
}

export class LoadProjectRelatedVersions implements Action {
    readonly type = ProjectsActionType.LoadProjectRelatedVersions;
    constructor() {}
}

export class LoadProjectRelatedVersionsSuccess implements Action {
    readonly type = ProjectsActionType.LoadProjectRelatedVersionsSuccess;
    constructor(public related: Array<Objects.Version>) {}
}

export class LoadProjectRelatedVersionsError implements Action {
    readonly type = ProjectsActionType.LoadProjectRelatedVersionsError;
    constructor(public error: HttpErrorResponse) {}
}

export class LoadProjectFilesNotesCounter implements Action {
    readonly type = ProjectsActionType.LoadProjectFilesNotesCounter;
    constructor() {}
}
export class LoadProjectFilesNotesCounterSuccess implements Action {
    readonly type = ProjectsActionType.LoadProjectFilesNotesCounterSuccess;
    constructor(public notes: Array<Objects.AnnotationsCounter>) {}
}

export class LoadProjectFilesNotesCounterError implements Action {
    readonly type = ProjectsActionType.LoadProjectFilesNotesCounterError;
    constructor(public error: HttpErrorResponse) {}
}

export class LoadPartialProjectSuccess implements Action {
    readonly type = ProjectsActionType.LoadPartialProjectSuccess;
    constructor(public header: Objects.BasicRequest) {}
}

export class LoadEvents implements Action {
    readonly type = ProjectsActionType.LoadEvents;
    constructor(public object: string, public id: number) {}
}

export class LoadEventsSuccess implements Action {
    readonly type = ProjectsActionType.LoadEventsSuccess;
    constructor(public events: Array<Objects.Event>) {}
}

export class LoadEventsError implements Action {
    readonly type = ProjectsActionType.LoadEventsError;
    constructor(public error: HttpErrorResponse) {}
}

export class LoadProjectEvents implements Action {
    readonly type = ProjectsActionType.LoadProjectEvents;
    constructor() {}
}

export class LoadProjectEventsSuccess implements Action {
    readonly type = ProjectsActionType.LoadProjectEventsSuccess;
    constructor(public events: Array<Objects.Event>) {}
}

export class LoadProjectEventsError implements Action {
    readonly type = ProjectsActionType.LoadProjectEventsError;
    constructor(public error: HttpErrorResponse) {}
}

export class LoadVersionsFeedbacks implements Action {
    readonly type = ProjectsActionType.LoadVersionsFeedbacks;
    constructor(public versions: Array<Objects.Version>) {}
}

export class LoadVersionsFeedbacksSuccess implements Action {
    readonly type = ProjectsActionType.LoadVersionsFeedbacksSuccess;
    constructor(public feedbacks: Array<VersionFeedback>) {}
}

export class LoadVersionsFeedbacksError implements Action {
    readonly type = ProjectsActionType.LoadVersionsFeedbacksError;
    constructor(public error: HttpErrorResponse) {}
}


export class UpdateProject implements Action {
    readonly type = ProjectsActionType.UpdateProject;
    constructor(public projectId: number, public event: string) {}
}

export class UpdateProjectMessages implements Action {
    readonly type = ProjectsActionType.UpdateProjectMessages;
    constructor(public projectId: number) {}
}

export class UpdateVersionsFeedbacks implements Action {
    readonly type = ProjectsActionType.UpdateVersionsFeedbacks;
    constructor(public versionId: number) {}
}

export class UpdateRelatedVersion implements Action {
    readonly type = ProjectsActionType.UpdateRelatedVersion;
    constructor(public versionId: number) {}
}

export class SetRelatedVersionStatus implements Action {
    readonly type = ProjectsActionType.SetRelatedVersionStatus;
    constructor(public groupId: string, public version: Objects.Version, public status: Objects.Status) {}
}

export class SetRelatedVersionStatusSuccess implements Action {
    readonly type = ProjectsActionType.SetRelatedVersionStatusSuccess;
    constructor(public version: Objects.Version) {}
}

export class SetRelatedVersionStatusError implements Action {
    readonly type = ProjectsActionType.SetRelatedVersionStatusError;
    constructor(public error: HttpErrorResponse, public groupId: string, public version: Objects.Version) {}
}

export class SetUploadedVersionStatus implements Action {
    readonly type = ProjectsActionType.SetUploadedVersionStatus;
    constructor(public version: Objects.Version, public status: Objects.Status) {}
}

export class SetUploadedVersionStatusSuccess implements Action {
    readonly type = ProjectsActionType.SetUploadedVersionStatusSuccess;
    constructor(public version: Objects.Version) {}
}

export class SetUploadedVersionStatusError implements Action {
    readonly type = ProjectsActionType.SetUploadedVersionStatusError;
    constructor(public error: HttpErrorResponse, public version: Objects.Version) {}
}

export class ClearEditorTransitions implements Action {
    readonly type = ProjectsActionType.ClearEditorTransitions;
    constructor() {}
}

export class ClearEditorAccess implements Action {
    readonly type = ProjectsActionType.ClearEditorAccess;
    constructor() {}
}

export class ClearRelatedVersions implements Action {
    readonly type = ProjectsActionType.ClearRelatedVersions;
    constructor() {}
}
// Logbook actions definitions
export class ApplyLogbookSearchFilter implements Action {
    readonly type = ProjectsActionType.ApplyLogbookSearchFilter;
    constructor(public filter: Search.SearchAppliedFilter) {}
}

export class RemoveLogbookSearchFilter implements Action {
    readonly type = ProjectsActionType.RemoveLogbookSearchFilter;
    constructor(public filter: Search.SearchAppliedFilter) {}
}

export class SetLogbookSearchTerm implements Action {
    readonly type = ProjectsActionType.SetLogbookSearchTerm;
    constructor(public term: string) {}
}

export class UpdateLogbookResults implements Action {
    readonly type = ProjectsActionType.UpdateLogbookResults;
    constructor() {}
}

export class ClearLogbookSearch implements Action {
    readonly type = ProjectsActionType.ClearLogbookSearch;
    constructor() {}
}

export type ProjectsActions = 	LoadProject |
                                LoadProjectSuccess |
								LoadProjectError |
                                SetProjectInfo |
                                SetProjectInfoSuccess |
                                SetProjectInfoError |
                                LoadWithUploadedVersions |
                                LoadWithUploadedVersionsSuccess |
								LoadWithUploadedVersionsError |
                                LoadProjectFiles |
                                LoadProjectFilesSuccess | 
                                LoadProjectFilesError | 
                                LoadProjectOriginVersion |
                                LoadProjectOriginVersionSuccess |
                                LoadProjectOriginVersionError | 
                                DeleteOneProjectFile |
                                DeleteOneProjectFileSuccess |
                                DeleteOneProjectFileError |
                                UploadProjectFiles |
                                UploadProjectFilesSuccess |
                                UploadProjectFilesError | 
                                LoadEditorAssigners |
                                LoadEditorAssignersSuccess |
                                LoadEditorAssignersError | 
                                LoadEditorWorkflowTransitions |
                                LoadEditorWorkflowTransitionsSuccess |
                                LoadEditorWorkflowTransitionsError |
                                SetEditorCurrentWorkflowTransitions |
                                SetEditorCurrentWorkflowTransitionsSuccess |
                                SetEditorCurrentWorkflowTransitionsError |
                                LoadEditorAccess |
                                LoadEditorAccessSuccess |
                                LoadEditorAccessError | 
                                SetProjectAssigned |
                                SetProjectAssignedSuccess |
                                SetProjectAssignedError | 
                                SetProjectDue |
                                SetProjectDueSuccess | 
                                SetProjectDueError |
                                SetProjectStatus |
                                SetProjectStatusSuccess |
                                SetProjectStatusError |
                                SetProjectLabels |
                                SetProjectLabelsSuccess |
                                SetProjectLabelsError | 
                                LoadProjectMessages |
                                LoadProjectMessagesSuccess |
                                LoadProjectMessagesError | 
                                LoadProjectRelatedVersions |
                                LoadProjectRelatedVersionsSuccess |
                                LoadProjectRelatedVersionsError |
                                LoadProjectUploadedVersions |
                                LoadProjectUploadedVersionsSuccess |
                                LoadProjectUploadedVersionsError | 
                                LoadProjectFilesNotesCounter |
                                LoadProjectFilesNotesCounterSuccess |
								LoadProjectFilesNotesCounterError |
                                LoadPartialProjectSuccess |
                                LoadProjectEvents |
                                LoadProjectEventsSuccess |
                                LoadProjectEventsError |
                                LoadEvents |
                                LoadEventsError |
                                LoadEventsSuccess | 
                                LoadVersionsFeedbacks |
                                LoadVersionsFeedbacksSuccess |
                                LoadVersionsFeedbacksError |
                                UpdateProject |
                                UpdateProjectMessages |
                                UpdateVersionsFeedbacks |
                                UpdateRelatedVersion |
                                SetRelatedVersionStatus |
                                SetRelatedVersionStatusSuccess |
                                SetRelatedVersionStatusError |
                                SetUploadedVersionStatus |
                                SetUploadedVersionStatusSuccess |
                                SetUploadedVersionStatusError |
                                Clear |
                                ClearEditorAccess |
                                ClearEditorTransitions |
                                ClearRelatedVersions |
                                ApplyLogbookSearchFilter |
                                RemoveLogbookSearchFilter |
                                SetLogbookSearchTerm |
                                UpdateLogbookResults |
                                ClearLogbookSearch
                                ;
